export default __webpack_public_path__ + "static/media/lb-hackathon-level-4.33eaa6a0.svg";